// extracted by mini-css-extract-plugin
export default {"page":"pagestyles_page__+UQTA","card":"pagestyles_card__akEi7"};